import React, { Component } from 'react';
import ThreeMap from './ThreeMap';


import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import Slider1 from 'rc-slider';
import 'rc-slider/assets/index.css';
// import xml2js from "xml2js";
import X2JS from 'x2js';
import Slider from 'react-slick';
import ReactPaginate from 'react-paginate';
import axios from 'axios';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import "./pageView.css";
import "./pageView_mb.css";

// Fix for VR_THUMBNAILS_MENU_KRPANO_V1.4 plugin missing var declarations
window.dh = 0;
window.hsh = 0;
window.hsv = 0;
window.a = 0;
window.h = 0;
window.v = 0;

const HOTSPOT_EN_MAP = {
    '恒立宣传片': 'Hengli Promo Video',
    '三连机作业': 'Triple Machine Operation',
    'RGV端点运输': 'RGV End-to-End Transport',
    '流线抬升机': 'Logistics Line Lifter',
    '机器人折弯': 'Robotic Bending',
    '校平机作业': 'Leveler Operation',
    '物流线出入口': 'Logistics Line Entry/Exit',
    '龙门激光切割机': 'Gantry Laser Cutter',
    '马扎克割管机': 'Mazak Pipe Cutting Machine',
    '火焰切割机': 'Flame Cutter',
    '大立库': 'Large-Scale Automated Vertical Warehouse',
    '通过式抛丸机': 'Pass-through Shot Blasting Machine',
    '辅料仓': 'Auxiliary Materials Warehouse',
    '三号楼三楼agv': 'Building 3 3F AGV',
    '小零件手工焊': 'Small Parts Manual Welding',
    '中捷落地镗': 'Zhongjie Floor Boring Machine',
    '大畏龙门': 'Okuma Gantry Machining Center',
    '加工中心': 'Machining Center',
    '钻攻中心': 'Drilling-Tapping Center',
    '离线编程': 'Offline Programming',
    '大库卡': 'Large KUKA Robot',
    '油漆': 'Painting',
    '喷砂': 'Sandblasting',
    '油压作业': 'Hydraulic Press Operation',
    '三楼机器人焊接': '3F Robotic Welding',
    '二楼物流线': '2F Logistics Line',
    '后部件产线': 'Rear Component Production Line',
    '前部件产线': 'Front Component Production Line',
    '油箱产线': 'Fuel Tank Production Line',
    '车架产线': 'Chassis Frame Production Line',
    '光谱分析仪': 'Spectrometer',
    '液压万能试验机': 'Hydraulic Universal Testing Machine',
    '冲击试验机': 'Impact Testing Machine',
    '自动转塔数显显微硬度计': 'Automatic Microhardness Tester',
    '金相显微镜': 'Metallographic Microscope',
    '触摸屏数显布氏硬度计': 'Touchscreen Brinell Hardness Tester',
    '盐雾试验机': 'Salt Spray Test Chamber',
    '氙灯耐候试验机': 'Xenon Lamp Weathering Tester',
    '桥式坐标测量机': 'Bridge Coordinate Measuring Machine'
};

class PageView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadNav: 0,
            loadShow: true,
            TipShow: false,
            leftShow: false,
            isEnNav: false,
            sceneNav: false,
            videoNav: false,
            classListNav: false,
            videoListNav: false,
            musicNav: false,
            sceneName: 'scene_001',
            sceneClass: '航拍',
            vrNav: false,
            rightShow: false,
            viewRotation: 0,
            addressNav: false,
            isPanoVideoPlay: false,
            videoTime: '00:00',
            videoTimeAll: '00:00',
            videoTimeScale: 0,
            isVideo: false,
            hotNav: false,
            hotName: '注塑新车间',
            hotIndex: 0,
            krpanoPage: '湖州',
            sceneClass2Sub: '',
            autoNav: false,
            daohangNav: false,
            searchLength: 0,
            searchNav: false,
            shareType: 0,
            searchType: 0,
            markerScenes: [],
            currentSceneName: '',
        };
        this.krpano = undefined;
        this.slider = null;
        this.isMouseDown = false;
        this.mousepos = { x: 0, y: 0 };
        this.mousepos1 = { x: 0, y: 0 };
        this.tween1 = null;
        this.audioRef = React.createRef();
        this.scenelist = React.createRef();
        this.centerRef = React.createRef();
        this.videoRef = React.createRef();
        this.isplaying = true
        this.sceneArr = {
        }
        this.scenepostionArr = {
            'scene_400': { x: 71, y: 67 },
            'scene_401': { x: 44, y: 45 },
            'scene_402': { x: 14, y: 51 },
            'scene_403': { x: 14, y: 66 },
            'scene_404': { x: 84, y: 48 },
            'scene_405': { x: 78, y: 66 },
            'scene_500': { x: 55, y: 83 },
            'scene_501': { x: 85, y: 54 },
            'scene_502': { x: 81.7, y: 54.8 },
            'scene_503': { x: 77.7, y: 40 },
            'scene_504': { x: 69.7, y: 40 },
            'scene_505': { x: 69.7, y: 45 },
            'scene_506': { x: 69.7, y: 49.5 },
            'scene_507': { x: 76.7, y: 49.5 },
            'scene_508': { x: 77.7, y: 62.7 },
            'scene_509': { x: 83.7, y: 62.7 },
            'scene_510': { x: 73.7, y: 62.7 },
            'scene_511': { x: 69.7, y: 62.7 },
            'scene_512': { x: 69.7, y: 56.7 },
            'scene_513': { x: 63.7, y: 62.7 },
            'scene_514': { x: 51.7, y: 62.7 },
            'scene_515': { x: 51.7, y: 54.7 },
            'scene_516': { x: 51.7, y: 47.7 },
            'scene_517': { x: 62.7, y: 47.7 },
            'scene_518': { x: 62.7, y: 41.7 },
            'scene_519': { x: 50.7, y: 41.7 },
            'scene_520': { x: 34.7, y: 41.7 },
            'scene_521': { x: 23.7, y: 41.7 },
            'scene_522': { x: 23.7, y: 47.7 },
            'scene_523': { x: 34.2, y: 47.7 },
            'scene_524': { x: 51.7, y: 72.6 },
            'scene_525': { x: 51.7, y: 78.3 },
            'scene_526': { x: 63.5, y: 78.3 },
            'scene_527': { x: 76.9, y: 78.3 },
            'scene_528': { x: 78.3, y: 85.9 },
            'scene_529': { x: 66.3, y: 85.9 },
            'scene_530': { x: 51.8, y: 85.9 },
            'scene_531': { x: 39.8, y: 85.9 },
            'scene_532': { x: 29, y: 85.9 },
            'scene_533': { x: 14.8, y: 85.9 },
            'scene_534': { x: 29, y: 78.4 },
            'scene_535': { x: 29, y: 72.6 },
            'scene_536': { x: 39.5, y: 72.6 },
            'scene_537': { x: 39.5, y: 78 },
            'scene_538': { x: 77.7, y: 57.2 },
            'scene_200': { x: 23.5, y: 41 },
            'scene_201': { x: 23.7, y: 32.2 },
            'scene_202': { x: 18.4, y: 33 },
            'scene_203': { x: 39.4, y: 32.6 },
            'scene_204': { x: 51.3, y: 32.6 },
            'scene_205': { x: 61.3, y: 32.6 },
            'scene_206': { x: 70.3, y: 32.6 },
            'scene_207': { x: 70, y: 41.6 },
            'scene_208': { x: 53, y: 41 },
            'scene_209': { x: 37.7, y: 41 },
            'scene_210': { x: 23.5, y: 41 },
            'scene_211': { x: 23.5, y: 47 },
            'scene_212': { x: 15.5, y: 47 },
            'scene_213': { x: 31.5, y: 47 },
            'scene_214': { x: 46.5, y: 47 },
            'scene_215': { x: 53, y: 47 },
            'scene_216': { x: 72, y: 49 },
            'scene_217': { x: 71.4, y: 56.5 },
            'scene_218': { x: 71.4, y: 66.5 },
            'scene_219': { x: 71.4, y: 77.5 },
            'scene_220': { x: 71.4, y: 82.5 },
            'scene_221': { x: 71.4, y: 88.5 },
            'scene_222': { x: 79.4, y: 87.4 },
            'scene_223': { x: 77.8, y: 82.4 },
            'scene_224': { x: 77.8, y: 77.4 },
            'scene_225': { x: 77.8, y: 56.4 },
            'scene_300': { x: 92.6, y: 71.7 },
            'scene_301': { x: 91.4, y: 68.3 },
            'scene_302': { x: 81.5, y: 68.3 },
            'scene_303': { x: 71.4, y: 71.4 },
            'scene_304': { x: 65, y: 71.4 },
            'scene_305': { x: 53.6, y: 72.3 },
            'scene_306': { x: 53.6, y: 65.5 },
            'scene_307': { x: 60, y: 66.2 },
            'scene_308': { x: 42.6, y: 71.1 },
            'scene_309': { x: 33.1, y: 70.7 },
            'scene_310': { x: 23.7, y: 71.1 },
            'scene_311': { x: 14.6, y: 69.1 },
            'scene_312': { x: 11.1, y: 63.5 },
        }
        this.sceneClass = []
        this.sceneClass1 = []
        this.sceneClass2 = []
        this.sceneClass11 = []
        this.sceneClass22 = []
        this.rect = null;
        this.x = 0;
        this.y = 0;
        this.scale = 1;
        this.minScale = 0.2;
        this.maxScale = 16;
        this.isPointerdown = false;
        this.lastPointermove = { x: 0, y: 0 };
        this.pano_video = null;
        this.videoTimeScale = 0;
        this.slider1 = null
        this.slider = null;
        this.hotimg = [
            [
                '弹簧自动试验机',
                '全自动影像测量机',
                '三维激光扫描仪',
                '三坐标测量机',
                '盐雾试验',
                '硬度视觉检测'
            ],
            [
                '注塑机机械手',
                '注塑新车间',
                '集中供料系统',
                'AP成型机（待安装）'
            ],
        ]
        this.x2js = new X2JS();
        this.autoArr = [
            {
                name: 'scene_1575',
                hlookat: -78.463
            },
            {
                name: 'scene_1565',
                hlookat: 0
            },
            {
                name: 'scene_1585',
                hlookat: -74.10
            },
            {
                name: 'scene_1175',
                hlookat: -119.48
            },
            {
                name: 'scene_1185',
                hlookat: -177.18
            },
            {
                name: 'scene_1555',
                hlookat: -180.04
            },
            {
                name: 'scene_1325',
                hlookat: 88.19
            },
            {
                name: 'scene_1315',
                hlookat: -5.99
            },
            {
                name: 'scene_1305',
                hlookat: -5.99
            },
            {
                name: 'scene_1295',
                hlookat: -5.99
            },
            {
                name: 'scene_1285',
                hlookat: -5.99
            },
            {
                name: 'scene_1275',
                hlookat: -5.99
            },
            {
                name: 'scene_1265',
                hlookat: 82.76
            },
            {
                name: 'scene_1195',
                hlookat: -177.17
            },
            {
                name: 'scene_1235',
                hlookat: -89.04
            },
            {
                name: 'scene_1225',
                hlookat: -89.04
            },
            {
                name: 'scene_1215',
                hlookat: -5.00
            },
            {
                name: 'scene_1205',
                hlookat: -84.74
            },
            {
                name: 'scene_1535',
                hlookat: -84.74
            },
            {
                name: 'scene_1105',
                hlookat: -84.74
            },
            {
                name: 'scene_1095',
                hlookat: -84.74
            },
            {
                name: 'scene_1085',
                hlookat: -84.74
            },
            {
                name: 'scene_1045',
                hlookat: -133.93
            },
            {
                name: 'scene_1035',
                hlookat: -178.72
            },
            {
                name: 'scene_1025',
                hlookat: -90
            },
            {
                name: 'scene_1695',
                hlookat: -90
            },
            {
                name: 'scene_1345',
                hlookat: -180
            },
            {
                name: 'scene_1355',
                hlookat: -180
            },
            {
                name: 'scene_1365',
                hlookat: -90
            },
            {
                name: 'scene_1375',
                hlookat: -90
            },
            {
                name: 'scene_1425',
                hlookat: 0
            },
            {
                name: 'scene_1435',
                hlookat: -90
            }
        ]
        this.autoArr1 = [
            {
                name: 'scene_ydtxdexflxpj201',
                hlookat: 0
            },
            {
                name: 'scene_ydtxdexukxkw101',
                hlookat: 90.61
            },
            {
                name: 'scene_xflxpj100',
                hlookat: 90.61
            },
            {
                name: 'scene_ydtxdexukxkw104',
                hlookat: 0
            },
            {
                name: 'scene_019',
                hlookat: 0
            },
            {
                name: 'scene_020',
                hlookat: 8.94
            },
            {
                name: 'scene_006',
                hlookat: 90
            },
            {
                name: 'scene_007',
                hlookat: 90
            },
            {
                name: 'scene_008',
                hlookat: 0
            },
            {
                name: 'scene_009',
                hlookat: 0
            },
            {
                name: 'scene_017',
                hlookat: 0
            },
            {
                name: 'scene_018',
                hlookat: -103
            },
            {
                name: 'scene_013',
                hlookat: 133.72
            },
            {
                name: 'scene_004',
                hlookat: 96.75
            },
            {
                name: 'scene_014',
                hlookat: 145.15
            },
            {
                name: 'scene_015',
                hlookat: 0
            },
            {
                name: 'scene_016',
                hlookat: -155.04
            },
            {
                name: 'scene_005',
                hlookat: -90
            },
            {
                name: 'scene_002',
                hlookat: -90
            },
            {
                name: 'scene_ydtxdexukxkw102',
                hlookat: 0
            },
        ]
        this.autoArrIndex = 0;
        this.searchRef = React.createRef();
        this.hotspotPerPage = window.innerWidth <= 768 ? 6 : 10;
        this.class = [

        ];
        this.class1 = []
        this.class2 = {}
        this.currentItems = []
        this.hotspotClassItems = []
        this.hotspot = [

        ]
        this.hotRandom = 0
    };


    componentDidMount() {

        // 获取当前日期和时间
        // const now = new Date();

        // 设置目标日期
        // const targetDate = new Date('2024-7-22');
        // const targetDate = new Date('2024-12-31');

        // // 比较当前日期是否已经过了目标日期
        // if (now > targetDate) {
        //     alert('系统错误，请联系管理员维护！！！')
        //     return
        // }
        if (!this.krpano) {
            this.initKrpano()
            let _this = this;
            window.PageView = this;
            window.sceneload = this.sceneload.bind(this)
            window.readyAddScene = this.readyAddScene.bind(this)
            window.changeName = this.changeName.bind(this)
            window.hotclick = this.hotclick.bind(this)
            window.onviewchange = this.onviewchange.bind(this)
            window.krpanoDownClick = this.stopAutoNav.bind(this)
            window.exitVR = this.exitVR.bind(this)
            window.enterVR = this.enterVR.bind(this)
            window.krpanoClick = this.krpanoClick.bind(this)
            window.closeVRPopup = this.closeVRPopup.bind(this)

            let num = 0;
            let loop = setInterval(() => {
                if (num == 100) {
                    clearInterval(loop)
                }
                this.setState({
                    loadNav: num++
                })
            }, 10);
            this.audioRef.current.addEventListener("play", () => {   //开始播放时触发
                this.setState({ musicNav: true })

            });
            this.audioRef.current.addEventListener("pause", () => {   //开始播放时触发
                this.setState({ musicNav: false })
            });
            this.audioRef.current.addEventListener("ended", () => {   //开始播放时触发
                this.setState({ musicNav: false })
            });
            var fun = (doc, win) => {
                var docEl = doc.documentElement,
                    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
                    recalc = () => {
                        var clientWidth = window.innerWidth;
                        var clientHeight = window.innerHeight;
                        if (!clientWidth || !clientHeight) return;

                        var sizeByW = clientWidth / 60;
                        // The UI requires about 40rem to 45rem of height. 
                        // Using 45 to ensure there's enough vertical breathing room without overflowing.
                        var sizeByH = clientHeight / 45;

                        var fontSize = Math.min(sizeByW, sizeByH);

                        docEl.style.fontSize = (fontSize < 12 ? 12 : fontSize) + 'px';
                    };
                if (!doc.addEventListener) return;
                win.addEventListener(resizeEvt, recalc, false);
                doc.addEventListener('DOMContentLoaded', recalc, false);
                recalc()
            }
            fun(document, window)

            document.addEventListener("fullscreenchange", (e) => {
                if (document.fullscreenElement) {
                    this.setState({
                        fullNav: true,
                    })
                } else {
                    this.setState({
                        fullNav: false,
                    })
                }
            })
            axios.get('./data.json').then((res) => {
                this.hotspot = res.data.hotspot
            })
        }
    }

    componentWillUnmount() {
    }

    initKrpano = config => {
        let _this = this;

        window.embedpano({
            xml: "./pano/tour.xml",
            target: "pano",
            bgcolor: "#000",
            html5: "webgl+only",
            mobilescale: 1.0,
            consolelog: true,
            passQueryParameters: true,
            onready: function (jsapi) {
                _this.krpano = jsapi.get("global");
                window.krpano = _this.krpano



            }
        });
    }
    readyAddScene = () => {
        let scenearr = this.krpano.get('scene').getArray()
        this.sceneArr = {}
        this.sceneClass1 = []   // 杭州 class1 列表
        this.sceneClass2 = []   // 湖州 class1 列表
        this.sceneClass11 = []  // 杭州 class1 对应英文
        this.sceneClass22 = []  // 湖州 class1 对应英文
        // 记录每个 厂区+class1 下的 class2 子类列表
        // 结构: { 湖州: { '车间名': ['子类A','子类B'] }, 杭州: {...} }
        this.sceneClassMap = {}
        // 二级分类英文映射（和 class2 同下标）
        this.sceneClassEnMap = {}

        // 中文 → 英文 映射（一级/二级通用）
        const CLASS_EN_MAP = {
            '一号车间': 'Workshop No.1',
            '二号车间': 'Workshop No.2',
            '三号车间': 'Workshop No.3',
            '四号车间': 'Workshop No.4',
            '工厂': 'Factory',
            '行政楼': 'Admin Building',
            '实验室': 'Laboratory',
            '室外': 'Outdoor',
            '航拍': 'Aerial View',
            '1F': 'Floor 1',
            '2F': 'Floor 2',
            '3F': 'Floor 3',
            'F1': 'Floor 1',
            'F2': 'Floor 2',
            'F3': 'Floor 3',
            '三号车间1层': 'Workshop No.3 1F',
            '三号车间2层': 'Workshop No.3 2F',
            '三号车间3层': 'Workshop No.3 3F',
        }
        this._classEnMap = CLASS_EN_MAP

        scenearr.map((val) => {
            // 杭州没有 class1 时补全
            if (val.class == '杭州' && !val.class1) {
                val.class1 = '杭州'
                val.class2 = '杭州'
            }
            if (val.title == val.name.substring(6)) {
                val.title = val.class + val.name.substring(6)
                val.title1 = val.class1 + val.name.substring(6)
            }

            // 三级分组：厂区 → class1（一级分类）→ class2（二级分类）→ [scenes]
            if (!this.sceneArr[val.class]) {
                this.sceneArr[val.class] = {}
            }
            if (!this.sceneArr[val.class][val.class1]) {
                this.sceneArr[val.class][val.class1] = {}
            }
            if (!this.sceneArr[val.class][val.class1][val.class2]) {
                this.sceneArr[val.class][val.class1][val.class2] = []
            }
            this.sceneArr[val.class][val.class1][val.class2].push(val)

            // 收集 class1 对应的 class2 子类列表
            if (!this.sceneClassMap[val.class]) {
                this.sceneClassMap[val.class] = {}
            }
            if (!this.sceneClassMap[val.class][val.class1]) {
                this.sceneClassMap[val.class][val.class1] = []
            }
            if (this.sceneClassMap[val.class][val.class1].indexOf(val.class2) == -1) {
                this.sceneClassMap[val.class][val.class1].push(val.class2)
                // 同步填充二级英文
                if (!this.sceneClassEnMap[val.class]) this.sceneClassEnMap[val.class] = {}
                if (!this.sceneClassEnMap[val.class][val.class1]) this.sceneClassEnMap[val.class][val.class1] = []
                this.sceneClassEnMap[val.class][val.class1].push(this._classEnMap[val.class2] || '')
            }

            // 收集各厂区 class1 列表
            if (val.class == '杭州' && this.sceneClass1.findIndex(itm => itm == val.class1) == -1) {
                this.sceneClass1.push(val.class1)
                this.sceneClass11.push(val.class2)
            } else if (val.class == '湖州' && this.sceneClass2.findIndex(itm => itm == val.class1) == -1) {
                this.sceneClass2.push(val.class1)
                this.sceneClass22.push(val.class2)
            }

            if (this.class.findIndex(itm => itm.class1 == val.class1) == -1) {
                this.class.push({
                    class1: val.class1,
                    class2: []
                })
            }
            if (this.class.find(itm => itm.class1 == val.class1).class2.findIndex(itm => itm == val.class2) == -1) {
                this.class.find(itm => itm.class1 == val.class1).class2.push(val.class2)
            }
            this.hotspot.push({
                name: val.title,
                name1: val.title1 || val.title,
                detail: [
                    val.thumburl
                ],
                scene: val.name,
                type: 1
            })
        })

        // 根据当前厂区填充导航分类列表，并默认选中第一个一级+二级分类
        const currentPage = this.state.krpanoPage
        this.sceneClass = currentPage == '湖州' ? this.sceneClass2 : this.sceneClass1
        const firstClass1 = this.sceneClass.length > 0 ? this.sceneClass[0] : ''
        const subList = (firstClass1 && this.sceneClassMap[currentPage]?.[firstClass1]) || []
        const firstClass2 = subList.length > 0 ? subList[0] : ''
        if (firstClass1 && !this.sceneArr[currentPage]?.[this.state.sceneClass]) {
            this.setState({ sceneClass: firstClass1, sceneClass2Sub: firstClass2 })
        }



        for (var key in this.sceneClass) {
            this.class1.push(key)
            for (var key1 in this.sceneClass[key]) {
                if (!this.class2[key]) this.class2[key] = []
                this.class2[key].push(key1)
            }
        }
        // this.hotspot.map((val) => {
        //     val.class = this.sceneArr[currentPage].find(itm => itm.name == val.scene).class1
        // })
    }
    getSceneMeta = (sceneName) => {
        return this.krpano?.get('scene')?.getArray()?.find(itm => itm.name == sceneName)
    }
    syncSceneState = (scene, extraState = {}, callback) => {
        if (!scene) return
        this.setState({
            ...extraState,
            krpanoPage: scene.class || this.state.krpanoPage,
            sceneName: scene.name || this.krpano?.xml?.scene || '',
            sceneClass: scene.class1 || '',
            sceneClass2Sub: scene.class2 || '',
        }, callback)
    }
    sceneload = () => {
        let scene = this.getSceneMeta(this.krpano?.xml?.scene);
        if (!scene) return
        this.syncSceneState(scene, {}, () => {
            if (this.scenelist.current) {
                for (var i = 0; i < this.scenelist.current.childNodes.length; i++) {
                    if (this.scenelist.current.childNodes[i].className == 'plane select') {
                        this.scenelist.current.scrollTop = this.scenelist.current.childNodes[i].offsetTop - window.innerHeight / 2 + this.scenelist.current.childNodes[i].clientHeight / 2
                    }
                }
            }
            this.updateMarkers({
                krpanoPage: scene.class,
                sceneClass: scene.class1,
                sceneClass2Sub: scene.class2,
            })
            if (this.isplaying) {
                setTimeout(() => {
                    this.audioRef.current.play()
                }, 1000)
            }
        })
        let _this = this
        console.log(window.krpano.xml.scene)

        this.hotspot.map((val, index) => {
            if (val.scene == window.krpano.xml.scene && (val.type == 2 || val.type == 3)) {
                this.add_img_hotspot(val.ath, val.atv, index, val.name, val.enName)
                console.log(val)
            }
        })


    }
    add_img_hotspot = (ath, atv, index, name, enName) => {
        this.hotRandom++
        if (this.hotRandom > 10000) this.hotRandom = 1000
        let hotName = 'hot_' + this.hotRandom;
        this.krpano.call('addhotspot(' + hotName + ', h1)');
        this.krpano.call('h1.loadstyle(hotclickstyle)');
        this.krpano.set('h1.ath', ath);
        this.krpano.set('h1.atv', atv);
        this.krpano.set('h1.hotindex', index);
        this.krpano.set('h1.edge', 'top');
        if (name) {
            this.krpano.set('h1.text', name);
        }
        if (enName) {
            this.krpano.set('h1.text1', enName);
        }
        this.krpano.call('callwith(hotspot[' + hotName + '], add_all_the_time_tooltip_for_VR)');

        console.log(this.hotRandom)
        console.log(this.krpano.get("h1"))

    }
    krpanoClick = () => {
        var hit = window.krpano.actions.screentosphere(this.krpano.mouse.x, this.krpano.mouse.y);
        var str = `"ath":${hit.x.toFixed(2)}, "atv":${hit.y.toFixed(2)},`
        // var str = `ath="${hit.x.toFixed(2)}" atv="${hit.y.toFixed(2)}"`
        // navigator.clipboard.writeText(str)
        console.log(str)

        if (this.state.rightShow || this.state.classListNav) {
            this.setState({
                rightShow: false,
                classListNav: false
            });
        }
    }
    onviewchange = () => {
    }
    changeName = (name, title) => {
        if (!this.state.isEnNav) {
            if (this.krpano.xml.scene == 'scene_100') {
                title = title.replace(/\d+/g, '')
            }
            window.krpano.set('hotspot[' + name + '].html', title)
        } else {
            if (this.krpano.get('scene').getArray().find(itm => itm.title == title)) {
                window.krpano.set('hotspot[' + name + '].html', this.krpano.get('scene').getArray().find(itm => itm.title == title).title1)
            } else {
                window.krpano.set('hotspot[' + name + '].html', title)
            }
            if (title == '沉浸式观看') {
                window.krpano.set('hotspot[' + name + '].html', 'Immersive viewing')
            }
        }

    }


    sceneClick = () => () => {
        this.setState({
            sceneNav: !this.state.sceneNav
        })
    }
    sceneLinkClick = (name) => () => {
        this.setState({
            addressNav: false
        })
        this.krpano.call('openscene(' + name + ')')
    }
    vrNavFun = () => () => {
        this.setState({
            vrNav: !this.state.vrNav,
        }, () => {
            if (this.state.vrNav) {
                window.krpano.get('plugin[webvr]').entervr();
            } else {

                window.krpano.get('plugin[webvr]').exitvr();
            }
        });
    }
    languageFun = (isEn) => () => {
        const newPage = isEn ? '杭州' : '湖州'
        // 切换厂区时更新分类导航列表
        this.sceneClass = newPage == '湖州' ? this.sceneClass2 : this.sceneClass1
        const firstClass = this.sceneClass.length > 0 ? this.sceneClass[0] : ''
        const firstSub = (this.sceneClassMap?.[newPage]?.[firstClass] || [])[0] || ''
        this.setState({
            loadShow: false,
            TipShow: true,
            krpanoPage: newPage,
            sceneClass: firstClass,
            sceneClass2Sub: firstSub
        })
        if (isEn) {
            this.krpano.call('loadscene(scene_ydtxdeaiqyln1,null,null,BLEND(0))')
        } else {
            this.krpano.call('loadscene(scene_ytjbxoyooanqaiqyln1xfoyzv,null,null,BLEND(0))')
        }
    }
    pageFun = (targetPage) => () => {
        let newPage = targetPage;
        if (!newPage) {
            newPage = this.state.krpanoPage !== '杭州' ? '杭州' : '湖州';
        }
        if (newPage === this.state.krpanoPage) {
            return;
        }
        this.sceneClass = newPage == '湖州' ? this.sceneClass2 : this.sceneClass1
        const firstClass = this.sceneClass.length > 0 ? this.sceneClass[0] : ''
        const firstSub = (this.sceneClassMap?.[newPage]?.[firstClass] || [])[0] || ''
        this.setState({
            krpanoPage: newPage,
            sceneClass: firstClass,
            sceneClass2Sub: firstSub
        })
        if (newPage == '杭州') {
            this.krpano.call('loadscene(scene_ydtxdeaiqyln1,null,null,BLEND(0))')
        } else {
            this.krpano.call('loadscene(scene_ytjbxoyooanqaiqyln1xfoyzv,null,null,BLEND(0))')
        }
    }
    tipFun = () => () => {
        this.setState({
            TipShow: false,
            leftShow: true
        })
    }
    classListFun = () => () => {
        this.setState({
            classListNav: !this.state.classListNav,
            videoListNav: false
        })
    }
    videoListFun = () => () => {
        this.setState({
            videoNav: true,
        })
        this.videoRef.current.play()
    }
    language1Fun = () => () => {
        this.setState({
            isEnNav: !this.state.isEnNav,
        }, () => {
            this.krpano.get('hotspot').getArray().map((val) => {
                if (this.state.isEnNav) {
                    val.url = val.url.replace("/image/", '/image1/')
                    if (val.type == 'text') {

                    }
                } else {
                    val.url = val.url.replace("/image1/", '/image/')
                }
            })
        })
        // this.krpano.jynav.forEach((item,index,self)=>{
        // 	if(item[0][1] == window.krpano.xml.scene){
        //         item[1] = []
        //     }
        // })
    }
    leftShowFun = () => () => {
        this.setState({
            videoListNav: false,
            classListNav: false,
            leftShow: !this.state.leftShow
        })
    }
    musicFun = () => () => {
        this.setState({
            musicNav: !this.state.musicNav
        }, () => {
            this.isplaying = this.state.musicNav
            if (this.isplaying) {
                this.audioRef.current.play()
            } else {
                this.audioRef.current.pause()
            }
        })
    }
    rightShowFun = () => () => {
        this.setState({
            rightShow: !this.state.rightShow
        })
    }
    classFun = (val) => () => {
        const page = this.state.krpanoPage
        // 取当前一级分类下的第一个二级分类
        const subList = this.sceneClassMap?.[page]?.[val] || []
        const firstSub = subList.length > 0 ? subList[0] : ''
        // 跳转到该二级下第一个场景
        const scenes = firstSub
            ? this.sceneArr[page]?.[val]?.[firstSub]
            : Object.values(this.sceneArr[page]?.[val] || {})[0]
        if (scenes && scenes.length > 0) {
            this.krpano.call('openscene(' + scenes[0].name + ')')
        }
        this.setState({
            rightShow: true,
            sceneClass: val,
            sceneClass2Sub: firstSub,
        }, () => {
            this.updateMarkers();
        })
    }
    closeVRPopup = () => {
        if (this.krpano) {
            try {
                this.krpano.call('callwith(hotspot[vr_popup_video], pause());');
                this.krpano.call('removehotspot(vr_popup_video);');
                this.krpano.call('removehotspot(vr_popup_img);');
                this.krpano.call('removehotspot(vr_popup_close);');
            } catch (e) {
                console.log('closeVRPopup error:', e);
            }
        }
    }
    showVRVideoPopup = (videoUrl) => {
        if (!this.krpano) return;
        this.closeVRPopup();

        let hlookat = Number(this.krpano.get('view.hlookat')) || 0;
        let vlookat = Number(this.krpano.get('view.vlookat')) || 0;

        if (this.audioRef.current) {
            this.audioRef.current.pause();
        }

        // 1. 在 3D 空间内创建 3D 视频热点 (调整默认宽度与最大高度)
        this.krpano.call('addhotspot(vr_popup_video)');
        this.krpano.set('hotspot[vr_popup_video].url', '%SWFPATH%/plugins/videoplayer.js');
        this.krpano.set('hotspot[vr_popup_video].videourl', videoUrl);
        this.krpano.set('hotspot[vr_popup_video].ath', hlookat);
        this.krpano.set('hotspot[vr_popup_video].atv', vlookat);
        this.krpano.set('hotspot[vr_popup_video].distorted', true);
        this.krpano.set('hotspot[vr_popup_video].edge', 'center');
        this.krpano.set('hotspot[vr_popup_video].width', 760);
        this.krpano.set('hotspot[vr_popup_video].height', 'prop');
        this.krpano.set('hotspot[vr_popup_video].maxheight', 480);
        this.krpano.set('hotspot[vr_popup_video].scale', 0.6);
        this.krpano.set('hotspot[vr_popup_video].pausedonstart', false);
        this.krpano.set('hotspot[vr_popup_video].loop', false);
        this.krpano.set('hotspot[vr_popup_video].zorder', 9990);
        this.krpano.set('hotspot[vr_popup_video].onvideocomplete', 'js(closeVRPopup());');

        // 2. 在 3D 视频右上角顶点处生成 3D 关闭按钮热点 (具备 distorted=true 3D 空间透视)
        this.krpano.call('addhotspot(vr_popup_close)');
        this.krpano.set('hotspot[vr_popup_close].url', './image/button_关闭.png');
        this.krpano.set('hotspot[vr_popup_close].ath', hlookat + 16.5);
        this.krpano.set('hotspot[vr_popup_close].atv', vlookat - 10);
        this.krpano.set('hotspot[vr_popup_close].distorted', true);
        this.krpano.set('hotspot[vr_popup_close].edge', 'center');
        this.krpano.set('hotspot[vr_popup_close].scale', 0.5);
        this.krpano.set('hotspot[vr_popup_close].zorder', 9999);
        this.krpano.set('hotspot[vr_popup_close].onclick', 'js(closeVRPopup());');
    }
    showVRImagePopup = (imageUrl) => {
        if (!this.krpano) return;
        this.closeVRPopup();

        let hlookat = Number(this.krpano.get('view.hlookat')) || 0;
        let vlookat = Number(this.krpano.get('view.vlookat')) || 0;

        // 1. 在 3D 空间内创建 3D 图片热点 (调整默认宽度与最大高度)
        this.krpano.call('addhotspot(vr_popup_img)');
        this.krpano.set('hotspot[vr_popup_img].url', imageUrl);
        this.krpano.set('hotspot[vr_popup_img].ath', hlookat);
        this.krpano.set('hotspot[vr_popup_img].atv', vlookat);
        this.krpano.set('hotspot[vr_popup_img].distorted', true);
        this.krpano.set('hotspot[vr_popup_img].edge', 'center');
        this.krpano.set('hotspot[vr_popup_img].width', 760);
        this.krpano.set('hotspot[vr_popup_img].height', 'prop');
        this.krpano.set('hotspot[vr_popup_img].maxheight', 480);
        this.krpano.set('hotspot[vr_popup_img].scale', 0.6);
        this.krpano.set('hotspot[vr_popup_img].zorder', 9990);

        // 2. 在 3D 图片右上角顶点处生成 3D 关闭按钮热点
        this.krpano.call('addhotspot(vr_popup_close)');
        this.krpano.set('hotspot[vr_popup_close].url', './image/button_关闭.png');
        this.krpano.set('hotspot[vr_popup_close].ath', hlookat + 16.5);
        this.krpano.set('hotspot[vr_popup_close].atv', vlookat - 10);
        this.krpano.set('hotspot[vr_popup_close].distorted', true);
        this.krpano.set('hotspot[vr_popup_close].edge', 'center');
        this.krpano.set('hotspot[vr_popup_close].scale', 0.5);
        this.krpano.set('hotspot[vr_popup_close].zorder', 9999);
        this.krpano.set('hotspot[vr_popup_close].onclick', 'js(closeVRPopup());');
    }
    hotclick = (index) => {
        if (!this.hotspot[index]) return;

        const isVRMode = this.state.vrNav || Boolean(window.krpano?.get('plugin[webvr]')?.isenabled);

        if (isVRMode) {
            const item = this.hotspot[index];
            if (item.type == 3 && item.detail && item.detail[0]) {
                this.showVRVideoPopup(item.detail[0]);
            } else if (item.type == 2 && item.detail && item.detail[0]) {
                this.showVRImagePopup(item.detail[0]);
            }
        } else {
            this.setState({ hotIndex: index, hotNav: true, rightShow: false, classListNav: false }, () => {
                if (this.hotspot[index].type == 3) {
                    this.audioRef.current?.pause();
                    this.videoRef.current?.play();
                }
            });
        }
    }
    cloasHotFun = () => () => {
        this.setState({
            hotNav: false, videoNav: false
        })
        this.videoRef.current.pause()
        this.videoRef.current.currentTime = 0
    }
    videoBack = () => () => {

        this.krpano.call('openscene(scene_301)')
    }
    fullFun = () => () => {
        this.setState({
            fullNav: !this.state.fullNav,
            moreNav: false
        }, () => {
            if (this.state.fullNav) {
                this.fullScreen()
            } else {
                this.exitFullscreen()
            }
        });
    }
    fullScreen() {
        var de = document.documentElement;
        if (de.requestFullscreen) {
            de.requestFullscreen();
        } else if (de.mozRequestFullScreen) {
            de.mozRequestFullScreen();
        } else if (de.webkitRequestFullScreen) {
            de.webkitRequestFullScreen();
        }
    }
    exitFullscreen() {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        }
    }
    autoNavFun = () => () => {
        this.setState({
            autoNav: !this.state.autoNav,
            moreNav: false
        }, () => {
            if (this.state.autoNav && this.state.krpanoPage == '湖州') {
                this.autoArrIndex = 1;
                if (this.autoArr.findIndex(itm => itm.name == this.krpano.xml.scene) > -1) {
                    this.autoArrIndex = this.autoArr.findIndex(itm => itm.name == this.krpano.xml.scene)
                    if (Math.abs(this.normalizeDeg(this.autoArr[this.autoArrIndex].hlookat) - this.normalizeDeg(this.krpano.view.hlookat)) > 20) {
                        this.krpano.call('lookto(' + this.normalizeDeg(this.autoArr[this.autoArrIndex].hlookat) + ',' + 0 + ',' + 120 + ',linear(60) )')
                    }
                } else {
                    this.autoArrIndex = 0
                    this.krpano.call(`loadscene(${this.autoArr[this.autoArrIndex].name},null,MERGE,BLEND(0.5,easeoutquad))`)

                }
                this.autoArrIndex++
                window.setInt = setInterval(() => {
                    if (this.autoArrIndex >= this.autoArr.length) {
                        this.stopAutoNav()
                        return
                    }
                    this.krpano.call(`set3dtransition("sphere",${this.krpano.view.hlookat},${this.krpano.view.vlookat},1000,0.5,0,0,0.5,easeoutquad)`)
                    this.krpano.call(`loadscene(${this.autoArr[this.autoArrIndex].name},null,MERGE,BLEND(0.5,easeoutquad))`)
                    setTimeout(() => {
                        if (Math.abs(this.normalizeDeg(this.autoArr[this.autoArrIndex].hlookat) - this.normalizeDeg(this.krpano.view.hlookat)) > 20) {
                            this.krpano.call('lookto(' + this.normalizeDeg(this.autoArr[this.autoArrIndex].hlookat) + ',' + 0 + ',' + 120 + ',linear(60) )')
                        }
                        this.autoArrIndex++
                    }, 500);
                }, 4000)
            } else if (this.state.autoNav && this.state.krpanoPage == '杭州') {
                this.autoArrIndex = 1;
                if (this.autoArr1.findIndex(itm => itm.name == this.krpano.xml.scene) > -1) {
                    this.autoArrIndex = this.autoArr1.findIndex(itm => itm.name == this.krpano.xml.scene)
                    if (Math.abs(this.normalizeDeg(this.autoArr1[this.autoArrIndex].hlookat) - this.normalizeDeg(this.krpano.view.hlookat)) > 20) {
                        this.krpano.call('lookto(' + this.normalizeDeg(this.autoArr1[this.autoArrIndex].hlookat) + ',' + 0 + ',' + 120 + ',linear(60) )')
                    }
                } else {
                    this.autoArrIndex = 0
                    this.krpano.call(`loadscene(${this.autoArr1[this.autoArrIndex].name},null,MERGE,BLEND(0.5,easeoutquad))`)

                }
                this.autoArrIndex++
                window.setInt = setInterval(() => {
                    if (this.autoArrIndex >= this.autoArr1.length) {
                        this.stopAutoNav()
                        return
                    }
                    this.krpano.call(`set3dtransition("sphere",${this.krpano.view.hlookat},${this.krpano.view.vlookat},1000,0.5,0,0,0.5,easeoutquad)`)
                    this.krpano.call(`loadscene(${this.autoArr1[this.autoArrIndex].name},null,MERGE,BLEND(0.5,easeoutquad))`)
                    setTimeout(() => {
                        if (Math.abs(this.normalizeDeg(this.autoArr1[this.autoArrIndex].hlookat) - this.normalizeDeg(this.krpano.view.hlookat)) > 20) {
                            this.krpano.call('lookto(' + this.normalizeDeg(this.autoArr1[this.autoArrIndex].hlookat) + ',' + 0 + ',' + 120 + ',linear(60) )')
                        }
                        this.autoArrIndex++
                    }, 500);
                }, 4000)
            } else {
                this.stopAutoNav()
            }
        });
    }
    normalizeDeg(deg) {
        return ((deg % 360) + 540) % 360 - 180;
    }
    stopAutoNav = () => {
        clearInterval(window.setInt);
        if (this.state.autoNav) {
            this.setState({
                autoNav: false,
                moreNav: false
            })
        }
    }
    exitVR = () => {
        this.clearVRSceneMenu();
        this.closeVRPopup();
        this.setState({ vrNav: false, vrMenuOpen: false })
    }
    enterVR = () => {
        this.setState({ vrNav: true, vrMenuOpen: true }, () => {
            setTimeout(() => {
                this.updateVRSceneMenu();
            }, 300);
        });
    }
    daohangFun = () => () => {
        this.setState({
            daohangNav: !this.state.daohangNav
        })
    }
    searchFun = (index) => () => {
        this.setState({
            searchNav: !this.state.searchNav
        }, () => {

            this.madeSearchArrFun()
        })
    }
    searchFun1 = (index) => () => {
        this.madeSearchArrFun()

    }
    searchClassFun = (val) => () => {
        this.setState({
            searchClass: val
        }, () => {
            this.madeSearchArrFun()
        })
        console.log(val)
    }
    searchTypeFun = (val) => () => {
        this.setState({
            searchType: val
        }, () => {
            this.madeSearchArrFun()
        })
    }
    getHotspotName = (item) => {
        if (!item) return '';
        if (this.state.isEnNav) {
            return item.name1 || HOTSPOT_EN_MAP[item.name] || item.name;
        }
        return item.name;
    }
    madeSearchArrFun = (index) => {
        this.hotspotClassItems = []

        this.hotspot.map((val) => {
            if (this.state.searchClass == '' || this.state.searchClass == val.class) {
                if (this.state.searchType == 0 || this.state.searchType == val.type) {
                    const query = this.searchRef.current ? this.searchRef.current.value.trim().toLowerCase() : '';
                    const cnName = val.name.toLowerCase();
                    const enName = (val.name1 || HOTSPOT_EN_MAP[val.name] || '').toLowerCase();
                    if (query == '' || cnName.indexOf(query) > -1 || enName.indexOf(query) > -1) {
                        this.hotspotClassItems.push(val)
                    }
                }
            }
        })
        this.setState({ searchLength: this.hotspotClassItems.length, currentPage: this.state.currentPage })

        const offset = this.state.currentPage * this.hotspotPerPage;
        this.currentItems = this.hotspotClassItems.slice(offset, offset + this.hotspotPerPage);

        if (this.state.currentPage == 0 && this.currentItems.length == 0) {

        } else if (this.currentItems.length == 0) {
            this.setState({ currentPage: 0 }, () => {
                this.madeSearchArrFun()
            })
        }
    }
    handlePageClick = (event) => {
        const offset = event.selected * this.hotspotPerPage;
        this.currentItems = this.hotspotClassItems.slice(offset, offset + this.hotspotPerPage);
        this.setState({
            currentPage: event.selected
        }, () => {
        })
    }
    hotListFun = (val) => () => {
        const targetScene = this.getSceneMeta(val.scene)
        if (targetScene) {
            this.syncSceneState(targetScene, { searchNav: false }, () => {
                this.updateMarkers({
                    krpanoPage: targetScene.class,
                    sceneClass: targetScene.class1,
                    sceneClass2Sub: targetScene.class2,
                })
            })
        } else {
            this.setState({ searchNav: false })
        }
        if (val.type == 1) {
            this.krpano.call("openscene(" + val.scene + ");")
        } else if (val.type == 2 || val.type == 3) {
            this.krpano.call("openscene(" + val.scene + ");")
            this.krpano.set('view.hlookat', val.ath);
            this.krpano.set('view.vlookat', val.atv);
        }
        console.log(val)
    }
    // ─── 提取 3D 模型列表（厂区 → class1 → class2）───────────────
    getModelList() {
        const list = [];
        const visited = new Set();
        for (const factory in this.sceneArr) {
            for (const class1 in this.sceneArr[factory]) {
                for (const class2 in this.sceneArr[factory][class1]) {
                    const key = `${class1}__${class2}`;
                    if (visited.has(key)) continue;
                    visited.add(key);
                    list.push({ factory, class1, class2 });
                }
            }
        }
        return list;
    }

    // ─── 获取带 pos3d 坐标的全景图标记列表（传给 ThreeMap）────────────
    getMarkerScenes(sceneClass2Sub, sceneClass, krpanoPage) {
        const currentPage = krpanoPage || this.state.krpanoPage;
        const currentClass = sceneClass || this.state.sceneClass;
        const currentClass2Sub = sceneClass2Sub !== undefined ? sceneClass2Sub : this.state.sceneClass2Sub;
        const scenesInGroup = this.sceneArr[currentPage]?.[currentClass];
        if (!scenesInGroup) return [];

        const markers = [];
        for (const class2 in scenesInGroup) {
            if (currentClass2Sub && class2 !== currentClass2Sub) continue;
            for (const scene of scenesInGroup[class2]) {
                if (scene.pos3dx !== undefined) {
                    markers.push({
                        sceneName: scene.name,
                        class2: scene.class2,
                        pos3d: [scene.pos3dx, scene.pos3dy, scene.pos3dz],
                    });
                }
            }
        }
        return markers;
    }

    // ─── 更新 state 中的标记球数据（切换模型/场景/分类时调用）────────
    updateMarkers(overrides = {}) {
        const markers = this.getMarkerScenes(
            overrides.sceneClass2Sub,
            overrides.sceneClass,
            overrides.krpanoPage
        );
        const sceneName = this.krpano ? (this.krpano.xml?.scene || '') : '';
        this.setState({ markerScenes: markers, currentSceneName: sceneName });
    }

    // ─── 点击 3D 标记球 → 跳转对应全景图 ───────────────────────────
    handleMarkerClick = (sceneName) => {
        if (this.krpano && sceneName) {
            console.log('handleMarkerClick', sceneName)
            this.krpano.call('openscene(' + sceneName + ')');
            // 跳转后更新当前场景名（让红球跟着走）
            setTimeout(() => this.updateMarkers(), 300);
        }
    }

    // ─── 获取当前场景名（用于 ThreeMap 标记红色当前项）───────────────
    getCurrentSceneName() {
        if (this.krpano) {
            return this.krpano.xml?.scene || '';
        }
        return '';
    }
    closeAlertFun = () => () => {
        this.setState({ hotNav: false })
        if (this.state.musicNav) {
            this.audioRef.current.play()
        }
    }
    render() {
        const settings = {
            dots: false,
            dotsClass: 'nav-btn',//自定义指示器的样式
            // dots: {'dot-style':String},
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
        };
        return <div className='container' >
            {/* <div className='btns-back' onClick={this.backClick()}></div> */}
            <audio ref={this.audioRef} src={'./music/bgmusic.mp3'} loop={false}></audio>
            <div className={this.state.loadShow ? 'loadDiv' : 'loadDiv transition loadDivhide '}>
                <img src='./image/首页.jpg' className='back-img pc-back' />
                <img src='./image/竖版首页.jpg' className='back-img mb-back' />
                <div className='text' style={{ display: this.state.loadNav == 100 ? 'none' : '' }}>{this.state.loadNav}%</div>

                <div className='btn-1' onClick={this.languageFun(true)}>
                    <span className='pulse-indicator'></span>
                    <div className="click-prompt">
                        <div>请点击这里</div>
                        <div style={{ fontSize: '0.8em', marginTop: '2px' }}>Please click here</div>
                    </div>
                </div>
                <div className='btn-2' onClick={this.languageFun(false)}>
                    <span className='pulse-indicator'></span>
                    <div className="click-prompt">
                        <div>请点击这里</div>
                        <div style={{ fontSize: '0.8em', marginTop: '2px' }}>Please click here</div>
                    </div>
                </div>
            </div>

            <div onClick={this.tipFun()} className={this.state.TipShow ? 'tipDiv' : 'tipDiv transition loadDivhide '}>
                <img src='./image/未标题-1.png' className='left-img ' />
                <div className='center'>
                    <img src='./image/img/direction/title.png' className='line1 ' />
                    <img src='./image/img/direction/hand_pc.png' className='line2 pc_show' />
                    <img src='./image/img/direction/text_pc.png' className='line3 pc_show' />
                    <img src='./image/img/direction/hand_mb.png' className='line2 mb_show' />
                    <img src='./image/img/direction/text_mb.png' className='line3 mb_show' />
                    <img src='./image/img/close.png' className='line4 ' />
                </div>
            </div>
            <div className='con-krpano container' id="pano"   >
                <img className='leftHideBtn' onClick={this.leftShowFun()} src='./image/显示@2x.png' style={{ display: this.state.leftShow ? 'none' : 'block' }} />
                <div className={this.state.leftShow ? 'leftdiv transition' : 'leftdiv lefthidediv transition'}>
                    <div className='rows'>
                        <div className='line'>
                            <img onClick={this.fullFun()} src={this.state.fullNav ? './image/全屏切换选中@2x.png' : './image/全屏切换@2x.png'} />
                            <div className="line-text" onClick={this.fullFun()}><span>全屏切换</span><span>Full Screen</span></div>
                        </div>
                        <div className={this.state.classListNav ? 'line select' : 'line'}>
                            <img onClick={this.classListFun()} src={this.state.classListNav ? './image/场景列表选中@2x.png' : './image/场景列表@2x.png'} />
                            <div className="line-text" onClick={this.classListFun()}><span>场景列表</span><span>Scene List</span></div>
                            <div className={'classList'} style={{ display: this.state.classListNav ? '' : 'none' }}>
                                {
                                    (() => {
                                        const cnList = this.state.krpanoPage == '湖州' ? this.sceneClass2 : this.sceneClass1
                                        const enMap = this.state.krpanoPage == '湖州' ? this.sceneClass22 : this.sceneClass11
                                        return cnList.map((val, index) => {
                                            const enVal = enMap[index] || ''
                                            return (
                                                <div key={index} className={'classList-item' + (this.state.sceneClass == val ? ' select' : '')}>
                                                    <div className='classList-item-label' onClick={this.classFun(val)}>
                                                        <span className='classList-item-cn'>{val}</span>
                                                        {this._classEnMap[val] && <span className='classList-item-en'>{this._classEnMap[val]}</span>}
                                                    </div>
                                                    {/* 二级分类（只在当前选中的一级下展开） */}
                                                    {this.state.sceneClass == val && (() => {
                                                        const page = this.state.krpanoPage
                                                        const subList = this.sceneClassMap?.[page]?.[val] || []
                                                        if (subList.length <= 1) return null
                                                        return (
                                                            <div className='classList-sub'>
                                                                {subList.map((sub, si) => {
                                                                    // 二级英文：从 sceneClassEnMap 取，没有就用 sub
                                                                    const subEn = (this.sceneClassEnMap?.[page]?.[val]?.[si]) || ''
                                                                    return (
                                                                        <div key={si}
                                                                            className={'classList-sub-item' + (this.state.sceneClass2Sub == sub ? ' select' : '')}
                                                                            onClick={() => {
                                                                                const scenes = this.sceneArr[page]?.[val]?.[sub]
                                                                                if (scenes && scenes.length > 0) {
                                                                                    this.krpano.call('openscene(' + scenes[0].name + ')')
                                                                                }
                                                                                this.setState({ sceneClass2Sub: sub }, () => {
                                                                                    this.updateMarkers();
                                                                                });
                                                                            }}
                                                                        >
                                                                            <span className='classList-sub-cn'>{sub}</span>
                                                                            {subEn && <span className='classList-sub-en'>{subEn}</span>}
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        )
                                                    })()}
                                                </div>
                                            )
                                        })
                                    })()
                                }
                            </div>
                        </div>
                        <div className={this.state.autoNav ? 'line select' : 'line'}>
                            <img onClick={this.autoNavFun()} src={this.state.autoNav ? './image/自动巡游选中@2x.png' : './image/自动巡游@2x.png'} />
                            <div className="line-text" onClick={this.autoNavFun()}><span>自动巡游</span><span>Auto Cruise</span></div>
                        </div>
                        <div className='line line-factory-switch'>
                            <div className="factory-switch-container">
                                <div className={`factory-btn ${this.state.krpanoPage == '杭州' ? 'active' : ''}`} onClick={this.pageFun('杭州')}>
                                    <img src="./image/杭州恒立.png" />
                                </div>
                                <div className="swap-icon" >
                                    <svg viewBox="0 0 36 24" width="44" height="28" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M26 2L32 8H4" />
                                        <path d="M10 22L4 16H32" />
                                    </svg>
                                </div>
                                <div className={`factory-btn ${this.state.krpanoPage == '湖州' ? 'active' : ''}`} onClick={this.pageFun('湖州')}>
                                    <img src="./image/浙江恒立.png" />
                                </div>
                            </div>
                            <div className="line-text" onClick={this.pageFun()}><span>工厂切换</span><span>Switch Works</span></div>
                        </div>
                        <div className='line'>
                            <img onClick={this.vrNavFun()} src={this.state.vrNav ? './image/VR浏览选中@2x.png' : './image/VR浏览@2x.png'} />
                            <div className="line-text" onClick={this.vrNavFun()}><span>VR预览</span><span>VR Panorama</span></div>
                        </div>
                        <div className='line'>
                            <img onClick={this.daohangFun()} src={this.state.daohangNav ? './image/导航选中@2x.png' : './image/导航@2x.png'} />
                            <div className="line-text" onClick={this.daohangFun()}><span>导航</span><span>Navigation</span></div>
                        </div>
                        <div className='line'>
                            <img onClick={this.searchFun()} src={this.state.searchNav ? './image/搜索@2x.png' : './image/搜索选中@2x.png'} />
                            <div className="line-text" onClick={this.searchFun()}><span>搜索</span><span>Search</span></div>
                        </div>
                    </div>
                </div>
                <img className={this.state.musicNav ? 'musicBtn musicPlay' : 'musicBtn'} onClick={this.musicFun()} src='./image/img/ui/bgm.png' />
                <div className={this.state.rightShow ? 'rightdiv transition' : 'rightdiv righthidediv transition'}>
                    <img src={this.state.rightShow ? './image/隐藏@2x.png' : './image/显示@2x.png'} onClick={this.rightShowFun()} />
                    <div className="click-prompt right-click-prompt">
                        <div>{this.state.rightShow ? '隐藏' : '显示'}</div>
                        <div style={{ fontSize: '0.8em', marginTop: '2px' }}>{this.state.rightShow ? 'Hide' : 'Show'}</div>
                    </div>
                    <div className='sceneList' ref={this.scenelist}>
                        {
                            (() => {
                                const page = this.state.krpanoPage
                                const cls1 = this.state.sceneClass
                                const cls2 = this.state.sceneClass2Sub
                                const subMap = this.sceneArr[page]?.[cls1] || {}
                                const scenes = cls2 && subMap[cls2]
                                    ? subMap[cls2]
                                    : Object.values(subMap).flat()
                                return scenes.map((val, index) =>
                                    <div key={index} className={this.state.sceneName == val.name ? 'plane select' : 'plane'} onClick={this.sceneLinkClick(val.name)}>
                                        <img src={val.thumburl}></img>
                                        <span data-scroll-text={this.state.isEnNav ? val.title1 : val.title}>{this.state.sceneName == val.name ? '' : (this.state.isEnNav ? val.title1 : val.title)}</span>
                                    </div>
                                )
                            })()
                        }
                    </div>
                </div>


                {
                    this.state.hotNav ?
                        <div className="hot-alert ">
                            {
                                this.hotspot[this.state.hotIndex].type == 2 ?

                                    <div className='centerBox'>
                                        <div className='left'>
                                            <img src={this.hotspot[this.state.hotIndex].detail[0]} alt="" />
                                            <div className='title'>{this.getHotspotName(this.hotspot[this.state.hotIndex])}</div>
                                        </div>
                                        <div className='right'>
                                            <div className='text'>{this.hotspot[this.state.hotIndex].text}</div>
                                            {
                                                this.hotspot[this.state.hotIndex].entext ?

                                                    <div className='entext'>{this.hotspot[this.state.hotIndex].entext}</div>
                                                    : <div></div>

                                            }

                                        </div>
                                    </div>
                                    : this.hotspot[this.state.hotIndex].type == 3 ?
                                        <video ref={this.videoRef}
                                            webkit-playsinline='true'
                                            playsInline={true}
                                            x5-video-player-type="h5"
                                            x5-video-player-fullscreen="true"
                                            x5-playsinline='true'
                                            x-webkit-airplay='allow'
                                            controls preload='true' src={this.hotspot[this.state.hotIndex].detail[0]}></video>


                                        : <div></div>
                            }
                            <div className="close" onClick={this.closeAlertFun()} >
                                <img src="./image/close.png" alt="" />
                            </div>
                        </div> : <div></div>
                }


                {
                    this.state.daohangNav ?
                        <div className="trpm-alert panoInfo-alert sys-skin3"  >
                            <div className="trpm-bk"></div>
                            <div className="trpm-mc" >
                                <div className='line1'>
                                    <span>导航</span>
                                    <img src="./image/button_关闭.png" onClick={this.daohangFun()} alt="" />
                                </div>
                                <div className='line2'>
                                    <iframe src='https://j.map.baidu.com/61/VWgf'></iframe>
                                </div>
                            </div>
                        </div> : <div></div>
                }
                {
                    this.state.searchNav ?
                        <div className="trpm-alert  panoInfo-alert sys-skin3"  >
                            <div className="trpm-bk"></div>
                            <div className="trpm-mc trpm-search " style={{ background: "transparent" }} >
                                <div className='line1'>
                                    <img src="./image/综合搜索.png" alt="" />
                                    <img src="./image/button_关闭.png" onClick={this.searchFun()} alt="" />
                                </div>
                                <div className='line2 '>
                                    <div className='line1'>
                                        <div className='selectBox'>
                                            <div className='select'>{this.state.searchClass ? this.state.searchClass : '---'} <b ></b></div>
                                            <div className='line'>
                                                <div onClick={this.searchClassFun('')}>---</div>
                                                {
                                                    this.class.map((item, idx) => (
                                                        <div
                                                            key={idx} onClick={this.searchClassFun(item.class1)}
                                                        >
                                                            <a >{item.class1}</a>
                                                        </div>
                                                    ))
                                                }
                                            </div>

                                        </div>
                                        <div className='link'>
                                            <img src="./image/icon_搜索框_搜索.png" alt="" />
                                            <input type='text' ref={this.searchRef} placeholder='请输入关键字' />
                                            <div onClick={this.searchFun1()}>搜索</div>
                                        </div>
                                    </div>
                                    <div className='line2'>
                                        <div onClick={this.searchTypeFun(0)} className={this.state.searchType == 0 ? 'select' : ''}>
                                            <img className='text' src="./image/导航_全部.png" alt="" />
                                        </div>
                                        <div onClick={this.searchTypeFun(1)} className={this.state.searchType == 1 ? 'select' : ''}>
                                            <img className='text' src="./image/导航_场景.png" alt="" />
                                        </div>
                                        <div onClick={this.searchTypeFun(2)} className={this.state.searchType == 2 ? 'select' : ''}>
                                            <img className='text' src="./image/导航_图片.png" alt="" />
                                        </div>
                                        <div onClick={this.searchTypeFun(3)} className={this.state.searchType == 3 ? 'select' : ''}>
                                            <img className='text' src="./image/导航_视频.png" alt="" />
                                        </div>
                                        <div onClick={this.searchTypeFun(4)} className={this.state.searchType == 4 ? 'select' : ''}>
                                            <img className='text' src="./image/导航_音频.png" alt="" />
                                        </div>
                                        <div onClick={this.searchTypeFun(5)} className={this.state.searchType == 5 ? 'select' : ''}>
                                            <img className='text' src="./image/导航_文本.png" alt="" />
                                        </div>
                                    </div>
                                    <div className='line3'>
                                        {this.currentItems.map((item, index) => (
                                            <div onClick={this.hotListFun(item)} key={index} className={'type' + item.type + ' item ' + this.state.currentPage}>
                                                {
                                                    item.type == 1 ?
                                                        <img src={`${item.detail[0]}`} /> :
                                                        item.type == 2 ?
                                                            <img src={`${item.detail[0]}`} /> :
                                                            item.type == 3 ?
                                                                <img src='./image/视频文件图标.png' /> :
                                                                item.type == 4 ?
                                                                    <img src='./image/音频文件图标.png' /> :
                                                                    <img src='./image/文本文件图标.png' />
                                                }
                                                <div className="search-item-title">
                                                    <div>{item.name}</div>
                                                    <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.7)', marginTop: '2px' }}>{item.name1 || HOTSPOT_EN_MAP[item.name] || ''}</div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className='line4'>
                                        <ReactPaginate
                                            pageCount={Math.ceil(this.state.searchLength / this.hotspotPerPage)}
                                            onPageChange={this.handlePageClick}
                                            containerClassName="pagination"
                                            activeClassName="active"
                                            previousLabel="<"
                                            nextLabel=">"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div> : <div></div>
                }
                {/* Three.js 3D 沙盘：工厂分类时显示 */}
                <ThreeMap
                    class1={this.state.sceneClass}
                    class2={this.state.sceneClass2Sub}
                    modelList={this.getModelList()}
                    onModelChange={(class1, class2) => {
                        this.setState({ sceneClass: class1, sceneClass2Sub: class2 }, () => {
                            this.updateMarkers();
                        });
                    }}
                    markerScenes={this.state.markerScenes}
                    currentSceneName={this.state.sceneName}
                    onMarkerClick={this.handleMarkerClick}
                    onclassFun={this.classFun}
                />
            </div>
        </div>
    }
}


export default PageView;
